import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend) // loads translations from your locales folder
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    ns: ['home', 'navbar', 'projects', 'papers', 'groups', 'team', 'project-detail', 'footer', 'errors', 'events'], // Specify the namespaces
    defaultNS: 'home', // Default namespace if not specified
    fallbackLng: 'en', // fallback language if the detected language isn't available
    debug: true,
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
